/** Shared-workspace disclosure shown on the sign-in gate and logged at startup. */
import { isDoltBackend } from "./dolt-mode";

export const SHARED_WORKSPACE_NOTICE =
  "TENURE uses a shared authenticated workspace. Workspace members can view, edit and delete the same scenarios, sites and builder quotes. Passcode access stays on this device only.";

const DOLT_WORKSPACE_NOTICE =
  "Your drafts are private to your account within the selected workspace. Changes stay on this device until you save a revision. Saved revisions are retained; other members cannot overwrite your draft.";

/** Disclosure shown on the sign-in gate and logged at startup (per backend mode). */
export function getWorkspaceNotice(): string {
  return isDoltBackend() ? DOLT_WORKSPACE_NOTICE : SHARED_WORKSPACE_NOTICE;
}
